import { createAction } from 'redux-actions'
import { takeLatest, call, put } from 'redux-saga/effects'
import { delivery as deliveryConfigApi } from 'services/api/'

export const actionTypes = {
    CREATE_DELIVERY_CONFIG: 'deliveryConfig/CREATE',
    CREATE_DELIVERY_CONFIG_SUCCESS: 'deliveryConfig/CREATE_SUCCESS',
    CREATE_DELIVERY_CONFIG_FAILED: 'deliveryConfig/CREATE_FAILED',

    DELETE_DELIVERY_CONFIG: 'deliveryConfig/DELETE',
    DELETE_DELIVERY_CONFIG_SUCCESS: 'deliveryConfig/DELETE_SUCCESS',
    DELETE_DELIVERY_CONFIG_FAILED: 'deliveryConfig/DELETE_FAILED',
    DELETE_DELIVERY_CONFIG_INIT: 'deliveryConfig/DELETE_FAILED',
}

export const actions = {
    create: createAction(actionTypes.CREATE_DELIVERY_CONFIG),
    createSuccess: createAction(actionTypes.CREATE_DELIVERY_CONFIG_SUCCESS),
    createFailed: createAction(actionTypes.CREATE_DELIVERY_CONFIG_FAILED),

    deleteDeliveryConfig: createAction(actionTypes.DELETE_DELIVERY_CONFIG),
    deleteSuccess: createAction(actionTypes.DELETE_DELIVERY_CONFIG_SUCCESS),
    deleteFailed: createAction(actionTypes.DELETE_DELIVERY_CONFIG_FAILED),
    deleteInit: createAction(actionTypes.DELETE_DELIVERY_CONFIG_INIT),
}

export const states = {
    create: {
        UNINITIALISED: 1,
        CREATING: 2,
        CREATED: 3,
        CREATE_FAILED: 4,
    },
    delete: {
        UNINITIALISED: 1,
        DELETING: 2,
        DELETED: 3,
        DELETE_FAILED: 4,
        INIT: 5,
    },
}

const INITIAL_STATE = {
    state: {
        create: states.create.UNINITIALISED,
        delete: states.delete.UNINITIALISED,
    },
}

export const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.CREATE_DELIVERY_CONFIG:
            return {
                ...state,
                state: {
                    ...state.state,
                    create: states.create.CREATING,
                },
            }
        case actionTypes.CREATE_DELIVERY_CONFIG_SUCCESS:
            return {
                ...state,
                state: {
                    ...state.state,
                    create: states.create.CREATED,
                },
            }
        case actionTypes.CREATE_DELIVERY_CONFIG_FAILED:
            return {
                ...state,
                state: {
                    ...state.state,
                    create: states.create.CREATE_FAILED,
                },
            }
        case actionTypes.DELETE_DELIVERY_CONFIG:
            return {
                ...state,
                state: {
                    ...state.state,
                    delete: states.delete.DELETING,
                },
            }

        case actionTypes.DELETE_DELIVERY_CONFIG_SUCCESS: {
            return {
                ...state,
                state: {
                    ...state.state,
                    delete: states.delete.DELETED,
                },
            }
        }

        case actionTypes.DELETE_DELIVERY_CONFIG_FAILED:
            return {
                ...state,
                state: {
                    ...state.state,
                    delete: states.delete.DELETE_FAILED,
                },
            }

        case actionTypes.DELETE_DELIVERY_CONFIG_INIT:
            return {
                ...state,
                state: {
                    ...state.state,
                    delete: states.delete.DELETE_INIT,
                },
            }

        default:
            return state
    }
}

export const selectors = {
    getCreateStatus: state => state.deliveryConfig.state.create,
    getDeliveryConfig: id => state => state.deliveryConfig.deliveryConfigs[id],
    getDeleteStatus: state => state.deliveryConfig.state.delete,
}

export const sagas = {
    onCreateDeliveryConfig: function* onCreateDeliveryConfig({ payload }) {
        try {
            const response = yield call(
                deliveryConfigApi.createDeliveryConfig,
                {
                    name: payload.name,
                    collectionId: payload.collectionId,
                    collectionReference: payload.collectionReference,
                    dataType: payload.dataType,
                    createdBy: payload.createdBy,
                },
            )
            yield put(actions.createSuccess(response))
        } catch (error) {
            yield put(actions.createFailed(error))
        }
    },

    onDeleteDeliveryConfig: function* onDeleteDeliveryConfig({ payload }) {
        try {
            yield call(deliveryConfigApi.deleteDeliveryConfig, payload)
            yield put(actions.deleteSuccess({ payload }))
        } catch (error) {
            yield put(actions.deleteFailed({ payload }))
        }
    },

    listen: function* listen() {
        yield takeLatest(
            actionTypes.CREATE_DELIVERY_CONFIG,
            sagas.onCreateDeliveryConfig,
        )
        yield takeLatest(
            actionTypes.DELETE_DELIVERY_CONFIG,
            sagas.onDeleteDeliveryConfig,
        )
    },
}
